import {
  SET_ERROR_CODE,
  CLEAR_ERROR_CODE,
} from '../../../src/store/actions/errorStatus';

const initialState = {
  code: null,
};

export const errorReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ERROR_CODE:
      return { ...state, code: action.payload };
    case CLEAR_ERROR_CODE:
      return { ...state, code: null };
    default:
      return state;
  }
};
